import Abstract from './editable/abstract';
import { Default, Email, Float, Number, Password, Textarea, Url } from './editable/default';
import { Date, DateTime } from './editable/date';
import Checkbox from './editable/checkbox';
import Color from './editable/color';
import Select from './editable/select';
import Select2 from './editable/select2';
import Togglable from './editable/togglable';
import Taxonomy from './editable/taxonomy';
import { Attachment, Media } from './editable/media';
import MultiInput from './editable/multi_input';
import Wysiwyg from './editable/wysiwyg';
import Fullname from "./editable/fullname";
var EditableMiddleware = /** @class */ (function () {
    function EditableMiddleware(editables) {
        this.Editables = editables;
        this.middleware = new Map();
        this.middleware.set('_abstract', Abstract);
        this.middleware.set('default', Default);
        this.middleware.set('text', Default);
        this.middleware.set('url', Url);
        this.middleware.set('number', Number);
        this.middleware.set('password', Password);
        this.middleware.set('email', Email);
        this.middleware.set('checklist', Checkbox);
        this.middleware.set('color', Color);
        this.middleware.set('select', Select);
        this.middleware.set('select2_dropdown', Select2);
        this.middleware.set('date', Date);
        this.middleware.set('date_time', DateTime);
        this.middleware.set('textarea', Textarea);
        this.middleware.set('togglable', Togglable);
        this.middleware.set('attachment', Attachment);
        this.middleware.set('media', Media);
        this.middleware.set('float', Float);
        this.middleware.set('multi_input', MultiInput);
        this.middleware.set('types_multi_input', MultiInput);
        this.middleware.set('taxonomy', Taxonomy);
        this.middleware.set('wysiwyg', Wysiwyg);
        this.middleware.set('fullname', Fullname);
        document.dispatchEvent(new CustomEvent('AC_Editing_Register_Middleware', { detail: this }));
    }
    EditableMiddleware.prototype.register = function (name, object) {
        this.middleware.set(name, object);
        return this;
    };
    EditableMiddleware.prototype.get = function (column) {
        var middleware = this.middleware.get(column.editable.type);
        if (!middleware) {
            middleware = this.middleware.get('default');
        }
        return new middleware(this.Editables, column);
    };
    return EditableMiddleware;
}());
export default EditableMiddleware;
